import clsxm from '@/lib/clsxm';
import { Author, Maybe } from '@/lib/types';

import HygraphImage from '@/components/hygraph-image';
import Typography from '@/components/typography';

import { formatFullDate } from '@/utils/date-utils';

export type TemplateHeaderProps = {
  author: Author;
  updatedAt: string;
  minutes?: Maybe<number>;
};

export default function TemplateHeader({
  author,
  updatedAt,
  minutes,
}: TemplateHeaderProps) {
  return (
    <div className='flex w-full flex-col flex-wrap lg:flex-row'>
      <HeaderSection hasDivider>
        {author.profileImage && (
          <HeaderSection>
            <HygraphImage
              url={author.profileImage.url}
              width={author.profileImage.width}
              height={author.profileImage.height}
              className='h-14 w-14 overflow-hidden rounded-full'
            />
          </HeaderSection>
        )}

        <Typography.Text inline>By:</Typography.Text>
        <Typography.Text weight='bold' className='ml-1 ' inline>
          {author.name}
        </Typography.Text>
      </HeaderSection>

      <HeaderSection hasDivider={!!minutes && minutes > 0}>
        <Typography.TextSmall>
          <span className='hidden lg:inline'>Updated: </span>
          {formatFullDate(updatedAt)}
        </Typography.TextSmall>
      </HeaderSection>

      {!!minutes && minutes > 0 && (
        <HeaderSection>
          <Typography.TextSmall inline>Reading time: </Typography.TextSmall>
          <Typography.TextSmall weight='bold' className='ml-1' inline>
            {minutes} min
          </Typography.TextSmall>
        </HeaderSection>
      )}
    </div>
  );
}

type HeaderSectionProps = {
  children: React.ReactNode;
  hasDivider?: boolean;
};
const HeaderSection = ({ children, hasDivider }: HeaderSectionProps) => (
  <span
    className={clsxm(
      'mb-1 mr-4 flex h-14 flex-row items-center',
      hasDivider && 'border-r-typography border-r-[1px] pr-4'
    )}
  >
    {children}
  </span>
);
